import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { APP_ROUTES } from '@core/constants/routes';
import { AuthService } from '@core/services/auth/auth.service';
import { ProtectedRoutesLoaderService } from '@core/routes/protected-routes-loader.service';
import { LoggerService } from '@core/logging/logger.service';

export const redirectGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const protectedLoader = inject(ProtectedRoutesLoaderService);
  const log = inject(LoggerService).createContext('RedirectGuard');

  try {
    const isValid = await authService.isSessionValid();
    if (isValid) {
      // Ensure protected routes are loaded before redirecting authenticated user away from auth pages.
      await protectedLoader.loadProtectedRoutes();
      await router.navigateByUrl(APP_ROUTES.HOME, { replaceUrl: true });
      return false;
    }
    return true;
  } catch (error) {
    log.error('Redirect guard error', error);
    return true;
  }
};
